$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,42,1) 35%, rgba(0,212,255,1) 100%); color: #FFF; font-weight: bold; font-size: 50px;"
);




///////////////for right header menu drop down////////////////
  

    
    // $(".right-submenu").hide(); // Ensure submenu is hidden on page load

    // $(".menu-item-right").hover(
    //     function() {
    //         $(this).find(".right-submenu").stop(true, true).slideDown(200);
    //     },
    //     function() {
    //         $(this).find(".right-submenu").stop(true, true).slideUp(200);
    //     }
    // );



    $(".right-submenu").hide(); // Ensure submenu is hidden on page load

    function isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
    }

    // Desktop: Show on hover
    $(".menu-item-right").hover(
        function() {
            if (!isMobile()) {
                $(this).find(".right-submenu").stop(true, true).slideDown(200);
            }
        },
        function() {
            if (!isMobile()) {
                $(this).find(".right-submenu").stop(true, true).slideUp(200);
            }
        }
    );

    // Mobile: Show on click/tap
    $(".menu-item-right > a").on("click", function(e) {
        if (isMobile()) {
            e.preventDefault(); // Prevent link from navigating immediately
            let submenu = $(this).next(".right-submenu");

            if (submenu.is(":visible")) {
                submenu.slideUp(200);
            } else {
                $(".right-submenu").slideUp(200); // Close other open submenus
                submenu.slideDown(200);
            }
        }


    // Close submenu when clicking outside on mobile
    $(document).click(function(e) {
        if (isMobile() && !$(e.target).closest(".menu-item-right").length) {
            $(".right-submenu").slideUp(200);
        }
    });
});



  

////////home banner splide



 if ($("#splide1").length == 1 && $("#splide2").length == 1 && $("#splide3").length == 1 && $("#splide4").length == 1) {
    // splide
    const splide = new Splide("#splide1", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      dots: "false",
      perPage: 4,
      autoScroll: {
        speed: 1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

    const splide1 = new Splide("#splide2", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      perPage: 4,
      autoScroll: {
        speed: -1,
      },
      // Responsive breakpoint
      breakpoints: {
        991: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
        },
      },
    });

   const splide2 = new Splide("#splide3", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      dots: "false",
      perPage: 4,
      autoScroll: {
        speed: 1,
      },
      // Responsive breakpoint
      breakpoints: {
        1199: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
          height: '30rem',
          gap: '10px'
        },
        749: {
          perPage: 3,
        },
        575: {
          perPage: 2,
          height: '25rem',
        }
      },
    });

  const splide3 = new Splide("#splide4", {
      direction: "ttb",
      height: "80rem",
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: "false",
      perPage: 4,
      autoScroll: {
        speed: -1,
      },
      // Responsive breakpoint
      breakpoints: {
        1199: {
          perPage: 4,
          direction: "ltr",
          autoHeight: true,
          height: '30rem',
          gap: '10px'
        },
        749: {
          perPage: 3,
        },
        575: {
          perPage: 2,
          height: '25rem',
        }
      },
    });

    splide.mount(window.splide.Extensions);
    splide1.mount(window.splide.Extensions);
    splide2.mount(window.splide.Extensions);
    splide3.mount(window.splide.Extensions);
  } //end if


  
//Home Shop Collection Slider

$('.indx-2-slider').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 8,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow:"<div class='slick-prev pull-left'><svg width='14' height='22' viewBox='0 0 14 22' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><path d='M12.1167 0.000261065C12.4314 -0.00557464 12.7401 0.0865523 13.0002 0.263894C13.2603 0.441236 13.4588 0.695023 13.5683 0.990137C13.6777 1.28525 13.6928 1.6071 13.6113 1.91115C13.5299 2.21519 13.3559 2.4864 13.1136 2.68724L3.83802 10.6279L13.1193 18.5685C13.2888 18.6921 13.4309 18.8495 13.5366 19.0308C13.6423 19.2121 13.7092 19.4133 13.7332 19.6218C13.7572 19.8302 13.7377 20.0414 13.676 20.2419C13.6143 20.4425 13.5117 20.6281 13.3746 20.787C13.2376 20.9459 13.0691 21.0746 12.8798 21.1651C12.6904 21.2556 12.4844 21.3059 12.2747 21.3128C12.065 21.3197 11.8561 21.283 11.6613 21.2051C11.4665 21.1272 11.2899 21.0098 11.1427 20.8602L0.532288 11.7909C0.365421 11.6484 0.231437 11.4714 0.139565 11.2721C0.0476942 11.0728 0.000119209 10.8559 0.000119209 10.6365C0.000119209 10.417 0.0476942 10.2002 0.139565 10.0009C0.231437 9.80159 0.365421 9.62458 0.532288 9.48205L11.1427 0.384115C11.4116 0.144741 11.7568 0.00869654 12.1167 0.000261065Z' fill='currentColor'/></svg></div>",
   nextArrow:"<div class='slick-next pull-right'><svg width='14' height='22' viewBox='0 0 14 22' fill='currentColor' xmlns='http://www.w3.org/2000/svg'><path d='M1.62648 0.000261065C1.31177 -0.00557464 1.00302 0.0865523 0.742962 0.263894C0.482905 0.441236 0.284398 0.695023 0.17491 0.990137C0.0654226 1.28525 0.0503672 1.6071 0.131829 1.91115C0.21329 2.21519 0.387241 2.4864 0.629608 2.68724L9.90514 10.6279L0.623878 18.5685C0.454318 18.6921 0.312221 18.8495 0.206555 19.0308C0.100889 19.2121 0.0339481 19.4133 0.00995661 19.6218C-0.0140348 19.8302 0.00544456 20.0414 0.067165 20.2419C0.128885 20.4425 0.231507 20.6281 0.368553 20.787C0.505599 20.9459 0.674095 21.0746 0.863405 21.1651C1.05272 21.2556 1.25873 21.3059 1.46845 21.3128C1.67817 21.3197 1.88703 21.283 2.08187 21.2051C2.2767 21.1272 2.45328 21.0098 2.60044 20.8602L13.2109 11.7909C13.3777 11.6484 13.5117 11.4714 13.6036 11.2721C13.6955 11.0728 13.743 10.8559 13.743 10.6365C13.743 10.417 13.6955 10.2002 13.6036 10.0009C13.5117 9.80159 13.3777 9.62458 13.2109 9.48205L2.60044 0.384115C2.33157 0.144741 1.98638 0.00869654 1.62648 0.000261065Z' fill='currentColor'/></svg></div>",
   responsive: [
     {
       breakpoint: 1440,
       settings: {
         slidesToShow: 6,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     }
   ]
 });



  
//for smooth scroll

  
  // $('.scrlbtm a').on('click', function (event) {
  //   event.preventDefault(); // Prevent default anchor click behavior

  //   const target = $($(this).attr('href')); // Get the target element using the href value
  //   if (target.length) {
  //     $('html, body').animate(
  //       {
  //         scrollTop: target.offset().top, // Scroll to the target's top position
  //       },
  //       800, // Duration in milliseconds
  //       'swing' // Easing function
  //     );
  //   }
  // });




// Home Testimonial after before img

// document.querySelectorAll('.indxSec7-holder').forEach((holder) => {
//   const imgAfter = holder.querySelector('.img-wrapper:nth-of-type(2)');
//   const line = holder.querySelector('#line');
//   const sliderNew = holder.querySelector('#sliderBar');

//   if (imgAfter && line && sliderNew) {
//     sliderNew.addEventListener('input', () => {
//       const value = sliderNew.value;
//       line.style.left = `${value}%`;   
//       imgAfter.style.clipPath = `inset(0px 0px 0px ${value}%)`;
//     });

//     // Reset on double-click
//     sliderNew.addEventListener('dblclick', () => {
//       sliderNew.value = 50;
//       line.style.left = '50%';
//       imgAfter.style.clipPath = 'inset(0px 0px 0px 50%)';
//     });
//   }
// });



  
  

//index 5 slider
// var $slider = $('.indx-5-slider');
//   var $progressBar = $('.progress');
//   var $progressBarLabel = $( '.slider__label' );
  
//   $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
//     var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
//     $progressBar
//       .css('background-size', calc + '% 100%')
//       .attr('aria-valuenow', calc );
    
//     $progressBarLabel.text( calc + '% completed' );
//   });
//  $slider.slick({
//    dots: false,
//    arrows:true,
//    infinite: true,
//    speed: 300,
//    slidesToShow: 3,
//    slidesToScroll: 1,
//    adaptiveHeight: false,
//    responsive: [
//      {
//        breakpoint: 1199,
//        settings: {
//          slidesToShow: 3,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 992,
//        settings: {
//          slidesToShow: 3,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 768,
//        settings: {
//          slidesToShow: 2,
//          slidesToScroll: 1
//        }
//      },
//      {
//        breakpoint: 600,
//        settings: {
//          slidesToShow: 1,
//          slidesToScroll: 1
//        }
//      }
//    ]
//  });




//for FAQ

  
$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});

//For tab

  // $('ul.tabs').each(function(){
  //     var active, content, links = $(this).find('a');
  //     active = links.first().addClass('active');
  //     content = $(active.attr('href'));
  //     links.not(':first').each(function () {
  //       $($(this).attr('href')).hide();
  //     });
  //     $(this).find('a').click(function(e){
  //       active.removeClass('active');
  //       content.hide();
  //       active = $(this);
  //       content = $($(this).attr('href'));
  //       active.addClass('active');
  //       content.show();
  //       return false;
  //     });
  //   });


});



